
import { post } from '../../utils/http'

export function login(data) {
    return post('/auth/login', data);
}

export function verifyToken(data) {
    return post('/auth/verify', data);
}

export function forgotPassword(data) {
    return post('/auth/forgot_password', data);
}

export function sendSupportEmail(data) {
    return post('/user/sendSupportEmail', data);
}

export function resetPassword(data) {
    return post('/auth/reset_password', data);
}
